import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    // No minimum height: the card lives in a fixed one-screen grid, so the chart
    // has to shrink with the card instead of forcing an inner scrollbar.
    chartContainer: {
        height: "100%",
        width: "100%",
    },
    loadingWrapper: {
        alignItems: "center",
        display: "flex",
        height: "100%",
        justifyContent: "center",
    },
    metricToggle: {
        "& .MuiToggleButton-root": {
            fontFamily: "Source Sans 3",
            fontSize: 10,
            fontWeight: 700,
            lineHeight: 1.2,
            padding: theme.spacing(0.5, 1),
            textTransform: "uppercase",
        },
    },
}));
